import 'amb/directives';

import {carExplorerDirective} from './car-explorer.directive';
import {flyoutDirective} from './flyout.directive';
import {hoverSweepDirective} from './hover-sweep.directive';
import {iconDirective} from './icon.directive';
import {pannellumDirective} from './pannellum.directive';

import {compilerService} from 'amb/services/compiler.service';

compilerService.register('ambCarExplorer', carExplorerDirective);
compilerService.register('ambFlyout', flyoutDirective);
compilerService.register('ambHoverSweep', hoverSweepDirective);
compilerService.register('', iconDirective);
compilerService.register('ambPannellum', pannellumDirective);
